module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJElEQVQ4jaXTr07DcBTF8c+aJogVRzYzgeUVEAtqWB4AzcwcWBQWHAa/oBBYqmACwQsgqUCwhgTBRkJCAqJ/KM2WrOEr7z3nl/bec1sP33dqDLCLbWzltUfc4wZxVdyqPLCJEYaI6q/mzHCBcyQQVswn2F9iLIhwiC6OkQR5Y7SCucp+7hHK/nlY7d6+Xpuksef3Keitd/U7Azsbe1XZEHEoG1hUNV8ll+afX6Xy6e1F+nEJ1Uci7AayaZdM0viPuWD++WWSxvXyduB3VVB+9iIW9LaCRcImBLKQlPTWu0vFC3qPgSxhJf3OQHstrAu110L9zqBevg9l8TyQb6KY8gprnOGmiPKpLGFNOMNRMcRzjBuYx7mnvIVElu2phsfU+u85/wDps13npjJikgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/icon.png
// module id = zVkc
// module chunks = 3